<div class="form-row flex-align-center">
  <label>{{ Yii.t('app', 'Starts on:') }}</label>
  <div>
    <p-date-picker
      [inputStyle]="{width: '100px'}"
      [ngModel]="start_day"
      (ngModelChange)="changeStartDay($event)"
      dateFormat="yy-mm-dd"
    />
  </div>
</div>
<div class="form-row flex-align-center">
  <label>{{ Yii.t('app', 'Repeats:') }}</label>
  <div>
    <p-select
      [options]="setOfPeriods"
      optionLabel="title"
      optionValue="value"
      [style]="{width: '150px'}"
      [(ngModel)]="ssvc.settings.schedule.repeat_period"
      (onChange)="ssvc.changePeriod()"
    />
  </div>
</div>
@if (ssvc.settings.schedule.repeat_period == 'weekly') {
  <div class="form-row">
    <label>{{ Yii.t('app', 'Repeat on:') }}</label>
    <div class="flex-row gap-8px flex-align-center">
      @for (dayOfWeek of weekly_repeat_settings; track dayOfWeek.title) {
        <div class="flex-row gap-4px flex-align-center">
          <p-checkbox binary="true" [(ngModel)]="dayOfWeek.checked" type="checkbox"/>
          <span>{{ dayOfWeek.title }}</span>
        </div>
      }
    </div>
  </div>
}

@if (ssvc.settings.schedule.repeat_period == 'monthly') {
  <div class="form-row">
    <label>{{ Yii.t('app', 'Repeat on:') }}</label>
    <div class="flex-row gap-8px flex-align-center">
      @for (monthRepeat of setOfMonthSettings; track monthRepeat.value) {
        <div class="flex-row gap-4px flex-align-center">
          <p-radio-button type="radio" [value]="monthRepeat.value" [(ngModel)]="ssvc.settings.schedule.monthly_repeat_settings"/>
          <span>{{monthRepeat.title}}</span>
        </div>
      }
    </div>
  </div>
}

@if (ssvc.settings.schedule.repeat_period != 'no_repeat') {
  <div class="form-row">
    <label>{{ Yii.t('app', 'Ends:') }}</label>
    <div class="flex-col gap-16px">
      <div class="flex-row gap-8px">
        <p-radio-button
          value="never"
          [(ngModel)]="ssvc.settings.schedule.end_condition"
          (change)="ssvc.clearParams()"
          />
        <span>{{ Yii.t('app', 'Never') }}</span>
      </div>
      <div class="flex-row gap-8px flex-align-center">
        <p-radio-button
          value="occurrences_number"
          [(ngModel)]="ssvc.settings.schedule.end_condition"
          (change)="ssvc.clearParams()"/>
        <span>{{ Yii.t('app', 'After the Number of Occurrences:') }}</span>
        <p-input-number
          maxlength="2"
          min="1"
          [inputStyle]="{width: '40px'}"
          [disabled]="ssvc.settings.schedule.end_condition !='occurrences_number'"
          [(ngModel)]="ssvc.settings.schedule.end_condition_param_occurrences"
        />
      </div>
      <div class="flex-row gap-8px flex-align-center">
        <p-radio-button
          value="on_date"
          [(ngModel)]="ssvc.settings.schedule.end_condition"
          (change)="ssvc.clearParams()"
        />
        <span>{{ Yii.t('app', 'On') }}</span>
        <p-date-picker
          [disabled]="ssvc.settings.schedule.end_condition !='on_date'"
          [inputStyle]="{width: '100px'}"
          [ngModel]="end_day"
          (ngModelChange)="changeEndDay($event)"
          dateFormat="yy-mm-dd"
        />
      </div>
    </div>
  </div>
}
